export default {"src":"/_next/static/media/cart-bg.98bb91b9.svg","height":141,"width":2127,"blurWidth":0,"blurHeight":0};